import { render, staticRenderFns } from "./BuyMenu.vue?vue&type=template&id=6b547b11&scoped=true&"
import script from "./BuyMenu.vue?vue&type=script&lang=ts&"
export * from "./BuyMenu.vue?vue&type=script&lang=ts&"
import style0 from "./BuyMenu.vue?vue&type=style&index=0&id=6b547b11&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b547b11",
  null
  
)

export default component.exports